export const MESSAGE_DIVIDER = 'BLOCKQUOTE'
